const ANALITICS = {
  newAnalitics: "Nova estatística",
  editAnalitics: "Editar estatísticas",
  listAnalitics: "Lista de estatísticas",
  newAnalitic: "Novo painel de estatísticas",
  alert: "Lembre-se de não usar <strong>caracteres especiais</strong>.",
  placeholderName: "Nome",
  placeHolderUri: "Digite o URL do painel",
  save: "Salvar",
  clean: "Limpar",  

  name: "Estatisticas",
  url: "url",
  company: "Companhia",
  status: "Doença",
  actions: "Ações",
  selectCompany: "Selecione uma empresa",

  notifyName: "Digite um nome para estatísticas",
  notifyNameInvalid: "Indique um nome válido.",
  successStatistics: "Estatísticas criadas com sucesso!",
  updateSuccessStatistic: "Atualização bem-sucedida",
  erroStatistics: "Ocorreu um erro ao criar as estatísticas",

  emptyStatistic: "Não há estatísticas registradas.",
  deleteStatistic: "Excluir estatísticas:",
  alertMessage: "Esta opção não pode ser desfeita, tem certeza?",

  accept: "Aceitar",
  cancel: "Cancelar",
  update: "Atualizar",

  deleteStatistics: "Excluir estatísticas",
  NotAutorization: "Você não tem permissões para executar esta ação.",
  erroToDelete: "Ocorreu um erro ao excluir a estatística",
  disabledAction: "Ação não disponível no momento",

  tableStatistic: "Placa de dados de estudo",
  msgErrorUrlStatistic: "O URL não pertence a um quadro de dados de estudo incorporado válido."
};


export default { ANALITICS };
